import React from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import {
  Container,
  Drawer,
  SwipeableDrawer,
  CssBaseline,
  List,
  Divider,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { makeStyles, useTheme } from "@material-ui/core/styles";
// import LogoColor from "../assets/img/logo/corob.png";
import Logo from "./../../media/images/icons/corob.png";
import IWLogo from "./../../media/images/icons/logos.png";
import IMLogo from "./../../media/images/icons/Immenzza.png";
import PWSLogo from "./../../media/images/icons/PWS.png";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import clsx from "clsx";
import Session from "react-session-api";
import FormList from "../FormList";
import { Header } from "./AppBar";
import IconList from "./IconList";
import Global from "../../Global";
import { useEffect } from "react";
import { blue } from "@material-ui/core/colors";

const drawerWidth = "100px";

// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//   },
//   link: {
//     textDecoration: "none",
//     color: theme.palette.text.primary,
//   },
//   sublink: {
//     textDecoration: "none",
//     color: theme.palette.text.primary,
//     fontSize: 12,
//   },
//   subMenuStyle: {
//     padding: 2,
//     paddingLeft: 20,
//   },
//   // subMenuIcon: {
//   //   paddingLeft: 10,
//   //   paddingBottom: 25,
//   //   height: 1,
//   // },
//   drawer: {
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//   },
//   drawerOpen: {
//     width: drawerWidth,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   drawerClose: {
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     overflowX: "hidden",
//     width: theme.spacing(7) + 1,
//     [theme.breakpoints.up("sm")]: {
//       width: theme.spacing(9) + 1,
//     },
//   },
//   toolbar: {
//     height: "50px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: theme.spacing(0, 1),
//     background: theme.palette.primary.PSTColor,
//     ...theme.mixins.toolbar,
//   },
//   containerdiv: {
//     marginLeft: 0,
//   },
// }));


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "150",
  },
  link: {
    textDecoration: "none",
    // color: theme.palette.primary.text,
    color: theme.palette.secondary.text,
    hover: theme.palette.secondary.main,
    '&:hover': {
      color: "#5D8BF4",
    },
  },

  drawer: {
    width: "250px"
  },
  sublink: {
    textDecoration: "none",
    // color: theme.palette.primary.text,
    color: theme.palette.secondary.text,
    fontSize: 12,
    '&:hover': {
      color: "#5D8BF4",
    },
  },
  subMenuStyle: {
    padding: 2,
    paddingLeft: 20,
  },
  // subMenuIcon: {
  //   paddingLeft: 10,
  //   paddingBottom: 25,
  //   height: 1,
  // },
  drawer: {
    width: drawerWidth,
    //backgroundColor: theme.palette.secondary.main,
    background: theme.palette.secondary.PSTColor,
    color: theme.palette.primary.text,
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    backgroundcolor: theme.palette.secondary.main,
    color: theme.palette.primary.text,
    //background: theme.palette.primary.PSTColor, 
    background: theme.palette.secondary.PSTColor,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: theme.palette.primary.PSTColor,
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    height: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),

    // background: theme.palette.primary.PSTColor,
    ...theme.mixins.toolbar,
  },
  containerdiv: {
    // backgroundColor: theme.palette.primary.PSTColor,
    marginLeft: 0,
  },
}));

export default function Navbar({ setIsLoggedIn }) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [LogoPath, setLogoPath] = React.useState(Logo);
  // const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false);
  const [openMenuName, setOpenMenuName] = React.useState("");
  // const [open01, setOpen01] = React.useState(true);

  var open01 = true;

  const handleDrawerClose = () => {
    open01 = false
    setOpen(false);
    setOpenMenuName("");
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    setLogoPath(Logo);
    // if (Session.get("CompanyName") === "Icewarp") {
    //   setLogoPath(IWLogo);
    // } else if (Session.get("CompanyName") === "Powershell Technologies ") {
    //   setLogoPath(PWSLogo);
    // } else if (Session.get("CompanyName") === "Immenza") {
    //   setLogoPath(IMLogo);
    // }
  }, []);

  const handleLogOut = () => {
    Session.clear();
    setIsLoggedIn(false);
  };

  const handleMenuClick = (menuName, menutype) => {
    // debugger;
    // console.log(menuName);
    // setIsSubMenuOpen(!isSubMenuOpen);
    setOpenMenuName(menuName);
    if (menuName === "Home" || menuName === "TCR" || menuName === "Bulletin" || menuName === "Price List" || menuName === "Change Password") {
      open01 = false;
    } else if (menutype === 'mainmenu') {
      open01 = true;
    }
    else {
      open01 = false;
    }
  };

  const handlenewclick = (e) => {
    debugger;
    if (open01 !== true) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  const renderedNavList = Global.form_list.map((form) => {
    if (
      form.isMenuItem === 1 &&
      form.Authorization.includes(Session.get("UserType"))
    ) {
      const renderedSubMenuList = form.subMenu.map((sub) => {
        // debugger;
        if (
          sub.isMenuItem === 1 &&
          sub.Authorization.includes(Session.get("UserType"))
        ) {

          return (
            <Link key={sub.name} to={sub.path} className={classes.link}>
              <ListItem button className={classes.subMenuStyle} onClick={() => handleMenuClick(form.name, 'sabmenu')}>
                <ListItemIcon className={classes.subMenuStyle}>
                  <IconList name={sub.icon} />
                </ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.sublink }}
                  primary={sub.name}
                />
              </ListItem>
            </Link>
          );
        }
        // else {
        //   return <></>;
        // }
      });

      const renderNavCollapseIcon = () => {

        if (openMenuName === form.name && form.subMenu.length > 0) {
          return (
            <ListItemIcon style={{ marginLeft: "8rem" }}>
              <IconList name="ExpandLess" />
            </ListItemIcon>
          );
        } else if (openMenuName !== form.name && form.subMenu.length > 0) {
          return (
            <ListItemIcon style={{ marginLeft: "8rem" }}>
              <IconList name="ExpandMore" />
            </ListItemIcon>
          );
        } else {
          return <ListItemIcon />;
        }
      };
      if (form.subMenu.length > 0) {
        return (
          <div key={form.name} className={classes.link}>
            <ListItem
              name={form.name}
              button
              onClick={() => handleMenuClick(form.name, 'mainmenu')}
            >
              <ListItemIcon>
                <IconList name={form.icon} />
              </ListItemIcon>
              <ListItemText primary={form.name} />
              {renderNavCollapseIcon()}
            </ListItem>
            <Collapse
              in={openMenuName === form.name ? true : false}
              timeout="auto"
              unmountOnExit
            >
              {renderedSubMenuList}
            </Collapse>
          </div>
        );
      } else {
        return (
          <Link key={form.name} to={form.path} className={classes.link}>
            <ListItem
              name={form.name}
              button
              onClick={() => handleMenuClick(form.name, 'mainmenu')}
            >
              <ListItemIcon>
                <IconList name={form.icon} />
              </ListItemIcon>
              <ListItemText primary={form.name} />
            </ListItem>
          </Link>
        );
      }
    } else {
      return <></>;
    }
  });

  const renderedRouteList = Global.form_list.map((form) => {
    // debugger;
    return (
      <Route key={form.name} exact path={form.path}>
        <Container className={classes.containerdiv}>
          <main
          // className={clsx(classes.content, {
          //   [classes.contentShift]: open,
          // })}
          >
            <FormList name={form.name} />
          </main>
        </Container>
      </Route>
    );
  });

  const renderedSubRouteList = Global.form_list.map((form) => {
    return form.subMenu.map((sub) => {
      if (
        sub.isMenuItem === 1 &&
        sub.Authorization.includes(Session.get("UserType"))
      ) {
        return (
          <Route key={sub.name} exact path={sub.path}>
            <Container className={classes.containerdiv}>
              <main
              // className={clsx(classes.content, {
              //   [classes.contentShift]: open,
              // })}
              >
                <FormList name={sub.name} />
              </main>
            </Container>
          </Route>
        );
      }
      // else {
      //   return <></>;
      // }
    });
  });

  return (
    <Router>
      <div className={classes.root}>
        <CssBaseline />
        <Header
          IsNavOpen={open}
          handleDrawerOpen={handleDrawerOpen}
          handleLogOut={handleLogOut}
        />
        {/* <Drawer */}
        <SwipeableDrawer
          anchor="left"
          open={open}
          classes={classes.drawer}
          sx={{ width: "250px" }}

          onClick={(e) => handlenewclick(e)}
        // swipeAreaWidth={1}
        // onOpen={() => { }}
        // // variant="permanent"
        // className={clsx(classes.drawer, {
        //   [classes.drawerOpen]: open,
        //   [classes.drawerClose]: !open,
        // })}
        // classes={{
        //   paper: clsx({
        //     [classes.drawerOpen]: open,
        //     [classes.drawerClose]: !open,
        //   }),
        // }}
        >
          <div className={classes.toolbar}>
            <img
              src={LogoPath}
              alt="LOGO"
              style={{ height: "70%", width: "50%", alignContent: "center", marginRight: 45 }}
            />
            <IconButton onClick={handleDrawerClose} style={{ color: "black" }}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon style={{ color: "black" }} />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </div>
          <Divider />
          <List>{renderedNavList}</List>
        </SwipeableDrawer>
        {/* </Drawer> */}
        <Switch>
          {renderedRouteList}
          {renderedSubRouteList}
        </Switch>
      </div>
    </Router>
  );
}

// import React from "react";
// import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
// import {
//   Container,
//   Drawer,
//   SwipeableDrawer,
//   CssBaseline,
//   List,
//   Divider,
//   ListItem,
//   ListItemText,
// } from "@material-ui/core";
// import Collapse from "@material-ui/core/Collapse";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
// import Logo from "./../../media/images/icons/logos.png";
// import IWLogo from "./../../media/images/icons/logos.png";
// import IMLogo from "./../../media/images/icons/Immenzza.png";
// import PWSLogo from "./../../media/images/icons/PWS.png";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import IconButton from "@material-ui/core/IconButton";
// import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import clsx from "clsx";
// import Session from "react-session-api";
// import FormList from "../FormList";
// import { Header } from "./AppBar";
// import IconList from "./IconList";
// import Global from "../../Global";
// import { useEffect } from "react";

// const drawerWidth = "100px";

// // const useStyles = makeStyles((theme) => ({
// //   root: {
// //     display: "flex",
// //   },
// //   link: {
// //     textDecoration: "none",
// //     color: theme.palette.text.primary,
// //   },
// //   sublink: {
// //     textDecoration: "none",
// //     color: theme.palette.text.primary,
// //     fontSize: 12,
// //   },
// //   subMenuStyle: {
// //     padding: 2,
// //     paddingLeft: 20,
// //   },
// //   // subMenuIcon: {
// //   //   paddingLeft: 10,
// //   //   paddingBottom: 25,
// //   //   height: 1,
// //   // },
// //   drawer: {
// //     width: drawerWidth,
// //     flexShrink: 0,
// //     whiteSpace: "nowrap",
// //   },
// //   drawerOpen: {
// //     width: drawerWidth,
// //     transition: theme.transitions.create("width", {
// //       easing: theme.transitions.easing.sharp,
// //       duration: theme.transitions.duration.enteringScreen,
// //     }),
// //   },
// //   drawerClose: {
// //     transition: theme.transitions.create("width", {
// //       easing: theme.transitions.easing.sharp,
// //       duration: theme.transitions.duration.leavingScreen,
// //     }),
// //     overflowX: "hidden",
// //     width: theme.spacing(7) + 1,
// //     [theme.breakpoints.up("sm")]: {
// //       width: theme.spacing(9) + 1,
// //     },
// //   },
// //   toolbar: {
// //     height: "50px",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "flex-end",
// //     padding: theme.spacing(0, 1),
// //     background: theme.palette.primary.PSTColor,
// //     ...theme.mixins.toolbar,
// //   },
// //   containerdiv: {
// //     marginLeft: 0,
// //   },
// // }));


// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//     width: "150",
//   },
//   link: {
//     textDecoration: "none",
//     // color: theme.palette.primary.text,
//     // hover: theme.palette.secondary.main,
//     color: theme.palette.secondary.text,
//     hover: theme.palette.secondary.main,
//     '&:hover': {
//       color: "#5D8BF4",
//     },
//   },

//   drawer: {
//     width: "250px"
//   },
//   sublink: {
//     textDecoration: "none",
//     // color: theme.palette.primary.text,
//     color: theme.palette.secondary.text,
//     fontSize: 12,
//     '&:hover': {
//       color: "#5D8BF4",
//     },
//   },
//   subMenuStyle: {
//     padding: 2,
//     paddingLeft: 20,
//   },
//   // subMenuIcon: {
//   //   paddingLeft: 10,
//   //   paddingBottom: 25,
//   //   height: 1,
//   // },
//   drawer: {
//     width: drawerWidth,
//     backgroundColor: theme.palette.secondary.main,
//     color: theme.palette.primary.text,
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//   },
//   drawerOpen: {
//     width: drawerWidth,
//      backgroundcolor: theme.palette.secondary.main,
//      color: theme.palette.primary.text,
//     // background: theme.palette.primary.PSTColor,
//     background: theme.palette.secondary.PSTColor,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   drawerClose: {
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     background: theme.palette.primary.PSTColor,
//     overflowX: "hidden",
//     width: theme.spacing(7) + 1,
//     [theme.breakpoints.up("sm")]: {
//       width: theme.spacing(9) + 1,
//     },
//   },
//   toolbar: {
//     height: "50px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: theme.spacing(0, 1),

//     // background: theme.palette.primary.PSTColor,
//     ...theme.mixins.toolbar,
//   },
//   containerdiv: {
//     // backgroundColor: theme.palette.primary.PSTColor,
//     marginLeft: 0,
//   },
// }));


// export default function Navbar({ setIsLoggedIn }) {
//   const classes = useStyles();
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(false);
//   const [LogoPath, setLogoPath] = React.useState(Logo);
//   // const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false);
//   const [openMenuName, setOpenMenuName] = React.useState("");
//   // const [open01, setOpen01] = React.useState(true);

//   var open01 = true;

//   const handleDrawerClose = () => {
//     open01 = false
//     setOpen(false);
//     setOpenMenuName("");
//   };

//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   useEffect(() => {
//     setLogoPath(Logo);
//     // if (Session.get("CompanyName") === "Icewarp") {
//     //   setLogoPath(IWLogo);
//     // } else if (Session.get("CompanyName") === "Powershell Technologies ") {
//     //   setLogoPath(PWSLogo);
//     // } else if (Session.get("CompanyName") === "Immenza") {
//     //   setLogoPath(IMLogo);
//     // }
//   }, []);

//   const handleLogOut = () => {
//     Session.clear();
//     setIsLoggedIn(false);
//   };

//   const handleMenuClick = (menuName, menutype) => {
//     // debugger;
//     // console.log(menuName);
//     // setIsSubMenuOpen(!isSubMenuOpen);
//     setOpenMenuName(menuName);
//     if (menuName === "Home" || menuName === "TCR" || menuName === "Bulletin" || menuName === "Price List" || menuName === "Change Password") {
//       open01 = false;
//     } else if (menutype === 'mainmenu') {
//       open01 = true;
//     }
//     else {
//       open01 = false;
//     }
//   };

//   const handlenewclick = (e) => {
//     debugger;
//     if (open01 !== true) {
//       setOpen(false)
//     } else {
//       setOpen(true)
//     }
//   }

//   const renderedNavList = Global.form_list.map((form) => {
//     if (
//       form.isMenuItem === 1 &&
//       form.Authorization.includes(Session.get("UserType"))
//     ) {
//       const renderedSubMenuList = form.subMenu.map((sub) => {
//         // debugger;
//         if (
//           sub.isMenuItem === 1 &&
//           sub.Authorization.includes(Session.get("UserType"))
//         ) {

//           return (
//             <Link key={sub.name} to={sub.path} className={classes.link}>
//               <ListItem button className={classes.subMenuStyle} onClick={() => handleMenuClick(form.name, 'sabmenu')}>
//                 <ListItemIcon className={classes.subMenuStyle}>
//                   <IconList name={sub.icon} />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.sublink }}
//                   primary={sub.name}
//                 />
//               </ListItem>
//             </Link>
//           );
//         }
//         // else {
//         //   return <></>;
//         // }
//       });

//       const renderNavCollapseIcon = () => {

//         if (openMenuName === form.name && form.subMenu.length > 0) {
//           return (
//             <ListItemIcon style={{ marginLeft: "8rem" }}>
//               <IconList name="ExpandLess" />
//             </ListItemIcon>
//           );
//         } else if (openMenuName !== form.name && form.subMenu.length > 0) {
//           return (
//             <ListItemIcon style={{ marginLeft: "8rem" }}>
//               <IconList name="ExpandMore" />
//             </ListItemIcon>
//           );
//         } else {
//           return <ListItemIcon />;
//         }
//       };
//       if (form.subMenu.length > 0) {
//         return (
//           <div key={form.name} className={classes.link}>
//             <ListItem
//               name={form.name}
//               button
//               onClick={() => handleMenuClick(form.name, 'mainmenu')}
//             >
//               <ListItemIcon>
//                 <IconList name={form.icon} />
//               </ListItemIcon>
//               <ListItemText primary={form.name} />
//               {renderNavCollapseIcon()}
//             </ListItem>
//             <Collapse
//               in={openMenuName === form.name ? true : false}
//               timeout="auto"
//               unmountOnExit
//             >
//               {renderedSubMenuList}
//             </Collapse>
//           </div>
//         );
//       } else {
//         return (
//           <Link key={form.name} to={form.path} className={classes.link}>
//             <ListItem
//               name={form.name}
//               button
//               onClick={() => handleMenuClick(form.name, 'mainmenu')}
//             >
//               <ListItemIcon>
//                 <IconList name={form.icon} />
//               </ListItemIcon>
//               <ListItemText primary={form.name} />
//             </ListItem>
//           </Link>
//         );
//       }
//     } else {
//       return <></>;
//     }
//   });

//   const renderedRouteList = Global.form_list.map((form) => {
//     // debugger;
//     return (
//       <Route key={form.name} exact path={form.path}>
//         <Container className={classes.containerdiv}>
//           <main
//           // className={clsx(classes.content, {
//           //   [classes.contentShift]: open,
//           // })}
//           >
//             <FormList name={form.name} />
//           </main>
//         </Container>
//       </Route>
//     );
//   });

//   const renderedSubRouteList = Global.form_list.map((form) => {
//     return form.subMenu.map((sub) => {
//       if (
//         sub.isMenuItem === 1 &&
//         sub.Authorization.includes(Session.get("UserType"))
//       ) {
//         return (
//           <Route key={sub.name} exact path={sub.path}>
//             <Container className={classes.containerdiv}>
//               <main
//               // className={clsx(classes.content, {
//               //   [classes.contentShift]: open,
//               // })}
//               >
//                 <FormList name={sub.name} />
//               </main>
//             </Container>
//           </Route>
//         );
//       }
//       // else {
//       //   return <></>;
//       // }
//     });
//   });

//   return (
//     <Router>
//       <div className={classes.root}>
//         <CssBaseline />
//         <Header
//           IsNavOpen={open}
//           handleDrawerOpen={handleDrawerOpen}
//           handleLogOut={handleLogOut}
//         />
//         {/* <Drawer */}
//         <SwipeableDrawer
//           anchor="left"
//           open={open}
//           classes={classes.drawer}
//           sx={{ width: "250px" }}
//           onClick={(e) => handlenewclick(e)}
//         // swipeAreaWidth={1}
//         // onOpen={() => { }}
//         // // variant="permanent"
//         // className={clsx(classes.drawer, {
//         //   [classes.drawerOpen]: open,
//         //   [classes.drawerClose]: !open,
//         // })}
//         // classes={{
//         //   paper: clsx({
//         //     [classes.drawerOpen]: open,
//         //     [classes.drawerClose]: !open,
//         //   }),
//         // }}
//         >
//           <div className={classes.toolbar}>
//             <img
//               src={LogoPath}
//               alt="LOGO"
//               style={{ height: "60%", width: "60%" }}
//             />
//             <IconButton onClick={handleDrawerClose} style={{ color: "black" }}>
//               {theme.direction === "rtl" ? (
//                 <ChevronRightIcon style={{ color: "black" }} />
//               ) : (
//                 <ChevronLeftIcon />
//               )}
//             </IconButton>
//           </div>
//           <Divider />
//           <List>{renderedNavList}</List>
//         </SwipeableDrawer>
//         {/* </Drawer> */}
//         <Switch>
//           {renderedRouteList}
//           {renderedSubRouteList}
//         </Switch>
//       </div>
//     </Router>
//   );
// }

// import React from "react";
// import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
// import {
//   Container,
//   Drawer,
//   CssBaseline,
//   List,
//   Divider,
//   ListItem,
//   ListItemText,
// } from "@material-ui/core";
// import Collapse from "@material-ui/core/Collapse";
// import { makeStyles, useTheme } from "@material-ui/core/styles";
// import Logo from "./../../media/images/icons/logos.png";
// import IWLogo from "./../../media/images/icons/logos.png";
// import IMLogo from "./../../media/images/icons/Immenzza.png";
// import PWSLogo from "./../../media/images/icons/PWS.png";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import IconButton from "@material-ui/core/IconButton";
// import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
// import ChevronRightIcon from "@material-ui/icons/ChevronRight";
// import clsx from "clsx";
// import Session from "react-session-api";
// import FormList from "../FormList";
// import { Header } from "./AppBar";
// import IconList from "./IconList";
// import Global from "../../Global";
// import { useEffect } from "react";

// const drawerWidth = 240;

// // const useStyles = makeStyles((theme) => ({
// //   root: {
// //     display: "flex",
// //   },
// //   link: {
// //     textDecoration: "none",
// //     color: theme.palette.text.primary,
// //   },
// //   sublink: {
// //     textDecoration: "none",
// //     color: theme.palette.text.primary,
// //     fontSize: 12,
// //   },
// //   subMenuStyle: {
// //     padding: 2,
// //     paddingLeft: 20,
// //   },
// //   // subMenuIcon: {
// //   //   paddingLeft: 10,
// //   //   paddingBottom: 25,
// //   //   height: 1,
// //   // },
// //   drawer: {
// //     width: drawerWidth,
// //     flexShrink: 0,
// //     whiteSpace: "nowrap",
// //   },
// //   drawerOpen: {
// //     width: drawerWidth,
// //     transition: theme.transitions.create("width", {
// //       easing: theme.transitions.easing.sharp,
// //       duration: theme.transitions.duration.enteringScreen,
// //     }),
// //   },
// //   drawerClose: {
// //     transition: theme.transitions.create("width", {
// //       easing: theme.transitions.easing.sharp,
// //       duration: theme.transitions.duration.leavingScreen,
// //     }),
// //     overflowX: "hidden",
// //     width: theme.spacing(7) + 1,
// //     [theme.breakpoints.up("sm")]: {
// //       width: theme.spacing(9) + 1,
// //     },
// //   },
// //   toolbar: {
// //     height: "50px",
// //     display: "flex",
// //     alignItems: "center",
// //     justifyContent: "flex-end",
// //     padding: theme.spacing(0, 1),
// //     background: theme.palette.primary.PSTColor,
// //     ...theme.mixins.toolbar,
// //   },
// //   containerdiv: {
// //     marginLeft: 0,
// //   },
// // }));


// const useStyles = makeStyles((theme) => ({
//   root: {
//     display: "flex",
//   },
//   link: {
//     textDecoration: "none",
//     color: theme.palette.primary.text,
//     hover: theme.palette.secondary.main,
//     '&:hover': {
//       color: "#5D8BF4",
//     },
//   },

//   sublink: {
//     textDecoration: "none",
//     color: theme.palette.primary.text,
//     fontSize: 12,
//     '&:hover': {
//       color: "#5D8BF4",
//     },
//   },
//   subMenuStyle: {
//     padding: 2,
//     paddingLeft: 20,
//   },
//   // subMenuIcon: {
//   //   paddingLeft: 10,
//   //   paddingBottom: 25,
//   //   height: 1,
//   // },
//   drawer: {
//     backgroundColor: theme.palette.secondary.main,
//     color: theme.palette.primary.text,
//     width: drawerWidth,
//     flexShrink: 0,
//     whiteSpace: "nowrap",
//   },
//   drawerOpen: {
//     width: drawerWidth,
//     backgroundcolor: theme.palette.secondary.main,
//     color: theme.palette.primary.text,
//     background: theme.palette.primary.PSTColor,
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.enteringScreen,
//     }),
//   },
//   drawerClose: {
//     transition: theme.transitions.create("width", {
//       easing: theme.transitions.easing.sharp,
//       duration: theme.transitions.duration.leavingScreen,
//     }),
//     background: theme.palette.primary.PSTColor,
//     overflowX: "hidden",

//     width: theme.spacing(7) + 1,
//     [theme.breakpoints.up("sm")]: {
//       width: theme.spacing(9) + 1,
//     },
//   },
//   toolbar: {
//     height: "50px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "flex-end",
//     padding: theme.spacing(0, 1),

//     // background: theme.palette.primary.PSTColor,
//     ...theme.mixins.toolbar,
//   },
//   containerdiv: {
//     // backgroundColor: theme.palette.primary.PSTColor,
//     marginLeft: 0,
//   },
// }));


// export default function Navbar({ setIsLoggedIn }) {
//   const classes = useStyles();
//   const theme = useTheme();
//   const [open, setOpen] = React.useState(false);
//   const [LogoPath, setLogoPath] = React.useState(Logo);
//   // const [isSubMenuOpen, setIsSubMenuOpen] = React.useState(false);
//   const [openMenuName, setOpenMenuName] = React.useState("");

//   const handleDrawerClose = () => {
//     setOpen(false);
//     setOpenMenuName("");
//   };

//   const handleDrawerOpen = () => {
//     setOpen(true);
//   };

//   useEffect(() => {
//     setLogoPath(Logo);
//     // if (Session.get("CompanyName") === "Icewarp") {
//     //   setLogoPath(IWLogo);
//     // } else if (Session.get("CompanyName") === "Powershell Technologies ") {
//     //   setLogoPath(PWSLogo);
//     // } else if (Session.get("CompanyName") === "Immenza") {
//     //   setLogoPath(IMLogo);
//     // }
//   }, []);

//   const handleLogOut = () => {
//     Session.clear();
//     setIsLoggedIn(false);
//   };

//   const handleMenuClick = (menuName) => {
//     // debugger;
//     // console.log(menuName);
//     // setIsSubMenuOpen(!isSubMenuOpen);
//     setOpenMenuName(menuName);
//   };

//   const renderedNavList = Global.form_list.map((form) => {
//     if (
//       form.isMenuItem === 1 &&
//       form.Authorization.includes(Session.get("UserType"))
//     ) {
//       const renderedSubMenuList = form.subMenu.map((sub) => {
//         // debugger;
//         if (
//           sub.isMenuItem === 1 &&
//           sub.Authorization.includes(Session.get("UserType"))
//         ) {
//           return (
//             <Link key={sub.name} to={sub.path} className={classes.link}>
//               <ListItem button className={classes.subMenuStyle}>
//                 <ListItemIcon className={classes.subMenuStyle}>
//                   <IconList name={sub.icon} />
//                 </ListItemIcon>
//                 <ListItemText
//                   classes={{ primary: classes.sublink }}
//                   primary={sub.name}
//                 />
//               </ListItem>
//             </Link>
//           );
//         }
//         // else {
//         //   return <></>;
//         // }
//       });

//       const renderNavCollapseIcon = () => {
//         if (openMenuName === form.name && form.subMenu.length > 0) {
//           return (
//             <ListItemIcon style={{ marginLeft: "8rem" }}>
//               <IconList name="ExpandLess" />
//             </ListItemIcon>
//           );
//         } else if (openMenuName !== form.name && form.subMenu.length > 0) {
//           return (
//             <ListItemIcon style={{ marginLeft: "8rem" }}>
//               <IconList name="ExpandMore" />
//             </ListItemIcon>
//           );
//         } else {
//           return <ListItemIcon />;
//         }
//       };
//       if (form.subMenu.length > 0) {
//         return (
//           <div key={form.name} className={classes.link}>
//             <ListItem
//               name={form.name}
//               button
//               onClick={() => handleMenuClick(form.name)}
//             >
//               <ListItemIcon>
//                 <IconList name={form.icon} />
//               </ListItemIcon>
//               <ListItemText primary={form.name} />
//               {renderNavCollapseIcon()}
//             </ListItem>
//             <Collapse
//               in={openMenuName === form.name ? true : false}
//               timeout="auto"
//               unmountOnExit
//             >
//               {renderedSubMenuList}
//             </Collapse>
//           </div>
//         );
//       } else {
//         return (
//           <Link key={form.name} to={form.path} className={classes.link}>
//             <ListItem
//               name={form.name}
//               button
//               onClick={() => handleMenuClick(form.name)}
//             >
//               <ListItemIcon>
//                 <IconList name={form.icon} />
//               </ListItemIcon>
//               <ListItemText primary={form.name} />
//             </ListItem>
//           </Link>
//         );
//       }
//     } else {
//       return <></>;
//     }
//   });

//   const renderedRouteList = Global.form_list.map((form) => {
//     debugger;
//     return (
//       <Route key={form.name} exact path={form.path}>
//         <Container className={classes.containerdiv}>
//           <main
//             className={clsx(classes.content, {
//               [classes.contentShift]: open,
//             })}
//           >
//             <FormList name={form.name} />
//           </main>
//         </Container>
//       </Route>
//     );
//   });

//   const renderedSubRouteList = Global.form_list.map((form) => {
//     return form.subMenu.map((sub) => {
//       if (
//         sub.isMenuItem === 1 &&
//         sub.Authorization.includes(Session.get("UserType"))
//       ) {
//         return (
//           <Route key={sub.name} exact path={sub.path}>
//             <Container className={classes.containerdiv}>
//               <main
//                 className={clsx(classes.content, {
//                   [classes.contentShift]: open,
//                 })}
//               >
//                 <FormList name={sub.name} />
//               </main>
//             </Container>
//           </Route>
//         );
//       }
//       // else {
//       //   return <></>;
//       // }
//     });
//   });

//   return (
//     <Router>
//       <div className={classes.root}>
//         <CssBaseline />
//         <Header
//           IsNavOpen={open}
//           handleDrawerOpen={handleDrawerOpen}
//           handleLogOut={handleLogOut}
//         />
//         <Drawer
//           variant="permanent"
//           className={clsx(classes.drawer, {
//             [classes.drawerOpen]: open,
//             [classes.drawerClose]: !open,
//           })}
//           classes={{
//             paper: clsx({
//               [classes.drawerOpen]: open,
//               [classes.drawerClose]: !open,
//             }),
//           }}
//         >
//           <div className={classes.toolbar}>
//             <img
//               src={LogoPath}
//               alt="LOGO"
//               style={{ height: "60%", width: "60%" }}
//             />
//             <IconButton onClick={handleDrawerClose} style={{ color: "black" }}>
//               {theme.direction === "rtl" ? (
//                 <ChevronRightIcon style={{ color: "black" }} />
//               ) : (
//                 <ChevronLeftIcon />
//               )}
//             </IconButton>
//           </div>
//           <Divider />
//           <List>{renderedNavList}</List>
//         </Drawer>
//         <Switch>
//           {renderedRouteList}
//           {renderedSubRouteList}
//         </Switch>
//       </div>
//     </Router>
//   );
// }
